export const COPIES = {
	facebook: {
		title: 'Select a group to post in',
		description: 'We found groups likely to support your cause and created a post for you to share.',
	},
	reddit: {
		title: 'Select a subreddit to post in',
		description: 'We found communities likely to support your cause and created a post for you to share.',
	},
};
